export enum FecImportTrackingEvents {
  MappingsConfirmed = 'FEC Mappings Confirmed',
  StepViewed = 'FEC Import Step Viewed',
  SuccessClosed = 'FEC Success Closed',
  ThirdPartiesConfirmed = 'FEC Third Parties Confirmed',
  ThirdPartyAccountsViewed = 'FEC Third-Party Accounts Viewed',
  WizardClosed = 'FEC Import Wizard Closed',
}
